<template>
  <a-modal
      title="新注册运动员"
      :visible="visible"
      width="1000px"
      @ok="handleSubmit"
      okText="提交数据报送审核"
      @cancel="handleCancel"
    >
  <div class="organization">
    <a-form :form="form" class="form" @submit="handleSubmit">
      <div style="position: relative;width: 200px;float: left;z-index: 999;">
        <upload ref="upload" :length="1" :fixedNumber="[5,7]" :imgs="image" @uploadSuccess="uploadSuccess" :cutImg="true" :uploadTest="'一寸照片'"></upload>
      </div>
      <div>
        <a-form-item style="margin-bottom:5px;width: 40%;float: left;z-index: 999;" :wrapperCol="wrapperCol">
          <a-input addon-before="*姓名" placeholder="姓名" v-decorator="['name', { rules: [{required: true, whitespace:true, message: '请输入姓名'}]}]"/>
        </a-form-item>
        <a-form-item style="margin-bottom:5px;width: 35%;float: left;z-index: 999;margin-left: 1%;" :wrapperCol="wrapperCol">
          <span style="padding: 6px 11px 5px 11px;border: 1px solid #d9d9d9;border-radius: 4px 0 0 4px;">*国籍</span>
          <a-select style="width:200px;" v-model="valData.nationality" placeholder="请选择国籍" v-decorator="['nationality',{ rules: [{ required: true, message: '请选择国籍' }] },]">
            <a-select-option v-for="(item, index) in nationalityArr" :key="index" :value="item.name">
              {{ item.name }}|{{ item.english }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item style="margin-bottom:5px;width: 71.3%;float: left;z-index: 999;" :wrapperCol="wrapperCol">
          <a-input :addon-before="valData.nationality=='中国大陆'? '*身份证号': '*护照号'" placeholder="请输入证件号码" v-decorator="['card', { rules: [{required: true, whitespace:true, message: '请输入请输入证件号码'}]}]"/>
          <div class="col-row" v-if="valData.nationality!='中国大陆'">
              <a-date-picker v-model="valData.birthday" @change="birthdayChange" class="col-2" :placeholder="$t('请选择出生日期')"/>
              <a-select style="width:200px;" v-model="valData.sex" placeholder="请选择性别">
                <a-select-option :value="1">男</a-select-option>
                <a-select-option :value="2">女</a-select-option>
              </a-select>
            </div>
        </a-form-item>
        <a-form-item style="margin-bottom:5px;width: 71.3%;float: left;z-index: 999;" :wrapperCol="wrapperCol">
          <a-input addon-before="*学号" placeholder="学号" v-decorator="['studentId', { rules: [{required: true, whitespace:true, message: '请输入学号'}]}]"/>
        </a-form-item>
        <a-form-item style="margin-bottom:5px;width: 30%;float: left;z-index: 999;" :wrapperCol="wrapperCol">
          <a-input addon-before="*专业" placeholder="专业" v-decorator="['major', { rules: [{required: true, whitespace:true, message: '请输入专业'}]}]"/>
        </a-form-item>
        
        <a-form-item style="margin-bottom:5px;width: 30%;margin-left:2%;float: left;z-index: 999;" :wrapperCol="wrapperCol">
          <!-- <a-input addon-before="*组别" placeholder="组别" v-decorator="['titles', { rules: [{required: true, whitespace:true, message: '请输入组别'}]}]"/> -->
          <span style="padding: 6px 11px 5px 11px;border: 1px solid #d9d9d9;border-radius: 4px 0 0 4px;">*组别</span>
          <a-select style="width:200px;" placeholder="组别" v-decorator="['titles',{ rules: [{ required: true, message: '请选择组别' }] },]">
            <a-select-option value="甲组">甲组</a-select-option>
            <a-select-option value="乙组">乙组</a-select-option>
            <a-select-option value="丙A组">丙A组</a-select-option>
            <a-select-option value="丙B组">丙B组</a-select-option>
            <a-select-option value="丁组">丁组</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item style="margin-bottom:5px;width: 30%;margin-left:2%;float: left;z-index: 999;" :wrapperCol="wrapperCol">
          <span style="padding: 6px 11px 5px 11px;border: 1px solid #d9d9d9;border-radius: 4px 0 0 4px;">*学历</span>
          <a-select style="width:200px;" placeholder="学历" v-decorator="['educational',{ rules: [{ required: true, message: '请选择学历' }] },]">
            <a-select-option value="大专">大专</a-select-option>
            <a-select-option value="本科">本科</a-select-option>
            <a-select-option value="研究生">研究生</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item style="margin-bottom:5px;width: 30%;float: left;z-index: 999;" :wrapperCol="wrapperCol">
          <a-input addon-before="*联系电话" placeholder="联系电话" v-decorator="['mobile', { rules: [{required: true, whitespace:true, message: '请输入联系电话'}]}]"/>
        </a-form-item>
        <a-form-item style="margin-bottom:5px;width: 30%;margin-left:2%;float: left;z-index: 999;" :wrapperCol="wrapperCol">
          <span style="padding: 6px 11px 5px 11px;border: 1px solid #d9d9d9;border-radius: 4px 0 0 4px;">*入学时间</span>
          <a-date-picker v-model="valData.enrollmentDate" @change="enrollmentDateChange" placeholder="请选择入学时间"/>
        </a-form-item>
        <a-form-item style="margin-bottom:5px;width: 34%;margin-left:2%;float: left;z-index: 999;" :wrapperCol="wrapperCol">
          <span style="padding: 6px 11px 5px 11px;border: 1px solid #d9d9d9;border-radius: 4px 0 0 4px;">*预计毕业时间</span>
          <a-date-picker v-model="valData.graduationDate" @change="graduationDateChange" placeholder="请选择预计毕业时间"/>
        </a-form-item>
        
        <a-form-item style="margin-bottom:5px;" :wrapperCol="wrapperCol">
          附件上传：
          <hr style="color: #eee;"/>
          <div v-for="(item,index) in uploadImgList" :key="index" style="width: 300px;float: left;text-align: center;margin-top: 20px;">
            <a-upload
              name="file"
              :action="imgurl"
              listType="text"
              :showUploadList="false"
              @change="handleChangeImage($event, item.value)"
            >
              <div>
                <img v-if="valData[item.value]" :src="valData[item.value]" style="width:50px;height:50px;">
                <img v-else src="@comm/assets/img.png" style="width: 50px;">
                <div class="ant-upload-text">{{ item.name }}</div>
              </div>
            </a-upload>
          </div>
        </a-form-item>
      </div>
    </a-form>
  </div>
</a-modal>
</template>

<script>
import address from '@comm/config/address'
import Upload from '@comm/upload/Upload'
import matchFun from '@comm/utils/matchFun'
import nationalityUtil from '@comm/utils/nationalityUtil'
import { getAddressFullCodeByCode } from '@comm/utils/addressUtil'
import {checkIdCard, getBirthday, getSex} from '@comm/utils/IdCardUtils'
import { mapState } from 'vuex'
import config from '@comm/http/config'
export default {
  name: 'EditAgency',
  components: {
    Upload
  },
  data () {
    return {
      nationalityArr: nationalityUtil,
      imgurl: config.baseImgURL,
      matchFun: matchFun,
      title: '创建单位信息',
      visible: false,
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 24 }
      },
      data: null,
      image: [],
      address: address,
      programId: Number(this.$route.query.programId),
      valData: {
        id: null,
        nationality: '中国大陆',
        birthday: null,
        sex: null,
        enrollmentDate: null,
        graduationDate: null,
        cardImg: null,
        validateImg: null,
        noticeImg: null,
        recordImg: null
      },
      uploadImgList: [{
        name: '学信网学籍验证报告',
        value: 'validateImg'
      }, {
        name: '身份证正面',
        value: 'cardImg'
      }, {
        name: '身份证反面',
        value: 'cardBankImg'
      }, {
        name: '运动员技术等级截图',
        value: 'levelImg'
      }, {
        name: '入学通知书（新生）',
        value: 'noticeImg'
      }, {
        name: '录检表（新生）',
        value: 'recordImg'
      }, {
        name: '本科学籍证明(研究生)',
        value: 'graduateImg'
      }, {
        name: '专科学籍证明(专升本)',
        value: 'undergraduateImg'
      }],
      form: this.$form.createForm(this)
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.user.userInfo
    })
  },
  mounted () {
    this.formData()
  },
  methods: {
    show (item) {
      if (item !== null) {
        this.image = [this.matchFun.randomNumFile('image.jpg', item.image)]
        this.valData = {
          id: item.id,
          nationality: item.nationality,
          birthday: item.birthday,
          sex: item.sex,
          enrollmentDate: item.enrollmentDate,
          graduationDate: item.graduationDate,
          cardImg: item.cardImg,
          cardBankImg: item.cardBankImg,
          levelImg: item.levelImg,
          validateImg: item.validateImg,
          noticeImg: item.noticeImg,
          recordImg: item.recordImg,
          graduateImg: item.graduateImg,
          undergraduateImg: item.undergraduateImg
        }
        setTimeout(() => {
          this.form.setFieldsValue({
            nationality: item.nationality,
            educational: item.educational,
            name: item.name,
            card: item.card,
            major: item.major,
            studentId: item.studentId,
            titles: item.titles,
            mobile: item.mobile
          })
        })
       
        // console.log(this.valData,  111)
      } else {
        this.image = []
        this.valData = {
          id: null,
          nationality: '中国大陆',
          birthday: null,
          sex: null,
          enrollmentDate: null,
          graduationDate: null,
          cardImg: null,
          cardBankImg: null,
          levelImg: null,
          validateImg: null,
          noticeImg: null,
          recordImg: null
        }
        setTimeout(() => {
          this.form.setFieldsValue({
            nationality: '中国大陆',
            educational: '',
            name: '',
            card: '',
            major: '',
            studentId: '',
            titles: '',
            mobile: ''
          })
        })
      }
      this.visible = true
    },
    formData () {
      setTimeout(() => {
        this.form.setFieldsValue({
          nationality: '中国大陆'
        })
      })
    },
    handleSubmit (e) {
      e.preventDefault()
      this.form.validateFieldsAndScroll((err, values) => {
        if (!err) {
          // 去掉名称中的空格
          values.name = values.name.replace(/\s/g, '')
          
          if (this.image.length === 0) {
            this.$message.error('请上传寸件照')
            return
          }
          values.image = this.image[0].url
          values = Object.assign({}, values, this.valData)
          values.agencyName = this.userInfo.nickname
          if (values.nationality == '中国大陆') {
            if (values.card && checkIdCard(values.card)) {
              values.birthday = getBirthday(values.card)
              values.sex = getSex(values.card)
            } else {
              this.$message.error('身份证号码不正确')
              return
            }
          }
          this.register(values)
        }
      })
    },
    register (valData) {
      console.log(valData)
      this.$api.match.examineSave(valData).then(res => {
        if (res.status === 0) {
          this.$message.success('成功')
          this.handleCancel()
          this.$emit('ok', 0)
        } else {
          this.$message.warn(res.msg)
        }
      }).catch(err => {
        console.log(err)
      })
    },
    uploadSuccess (e) {
      this.image = e
    },
    handleChangeImage (info, item) {
      let fileList = [...info.fileList]
      fileList = fileList.slice(-1)
      if (fileList[0].response) {
        this.valData[item] = fileList[0].response.data.url
        console.log(this.valData)
        this.$forceUpdate()
      }
    },
    enrollmentDateChange (date, dateString) { // 日期选择器
      this.valData.enrollmentDate = dateString
    },
    graduationDateChange (date, dateString) {
      this.valData.graduationDate = dateString
    },
    birthdayChange (date, dateString) { // 日期选择器
      this.valData.birthday = dateString
    },
    handleCancel () {
      this.visible = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.organization{
  .title{
    color: #000;
    line-height: 50px;
    font-size: 16px;
    position: relative;
    .add-right-warp{
      position: absolute;
      right: 0;
      top: 0;
    }
    .add-right{
      display: inline-block;
      cursor: pointer;
      color: #000;
      border-radius: 2px;
      height: 35px;
      line-height: 35px;
      font-size: 14px;
      padding: 0 10px;
      border: 1px solid #e8e8e8;
    }
  }
  .list{
    .col{
      margin-bottom: 30px;
      float: left;
      width: 50%;
      &:nth-child(odd){
        .warp{
          margin-left: 3%;
        }
      }
    }
    .warp{
      width: 97%;
      height: 120px;
      border:1px solid #e8e8e8;
      border-radius: 2px;
      display: flex;
      flex-direction: row;
      position: relative;
      background-color:#fff;
      box-shadow: rgba(196, 196, 196, 0.5) 1px 1px 3px 1px;
      &:hover{
        cursor: pointer;
        background-color: #f7f7f7;
      }
      .or-img{
        width: 110px;
        height: 110px;
        border-radius: 50%;
        margin-top: auto;
        margin-bottom: auto;
        padding: 10px;
      }
      .content{
        height: 100%;
        display: flex;
        flex-direction: column;
        div{
          flex: 1;
          color: #000;
          line-height: 40px;
          margin-bottom: 0;
          .or-title{
            color: #999;
          }
        }
      }
      .check{
        position: absolute;
        right: 0;
        color: #fff;
        width: 80px;
        font-size: 28px;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        background-color: #e8e8e8;
      }
    }
    .active{
      .check{
        background-color: red;
      }
    }
  }
}
.organization /deep/ .ant-select-selection{
  border-left:none;
  border-radius: 0 4px 4px 0;
}
.organization /deep/ .ant-cascader-input{
  border-left:none;
  border-radius: 0 4px 4px 0;
}
.organization /deep/ .ant-calendar-picker-input{
  border-left:none;
  border-radius: 0 4px 4px 0;
}
</style>



// WEBPACK FOOTER //
// src/comm/components/join/joinFactory/EditPlayer.vue